<script>
export default {
  mounted() {
    import('/src/scripts/indexUtils.js');
  },
};
</script>
<template>
</template>